export default __webpack_public_path__ + "static/media/personalAccount.07883367.svg";